import { SandboxedTagMutation } from "@pjs/security";
import { DivCleanupMutation } from "./blocks/DivCleanupMutation";

export const divTransform: SandboxedTagMutation = new DivCleanupMutation();
